/*
  https://github.com/zebzhao/Angular-QueryBuilder
*/
import { Field } from 'ngx-angular-query-builder'
import { FilterOperators, FieldMetadata, FieldMetadataCollection, FilterFieldProvider, FilterListItem } from '../../common/filter/filtering';
import { SubLedgerModel } from '@feature/cash-balances/models/sub-ledger.model';

export class AdminCashBalancesFilterFieldProvider implements FilterFieldProvider {

  readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(
    private readonly subLedgers: Array<SubLedgerModel>,
    private readonly types: Array<string>) {
    this.initialiseFields();
  }

  private getQueryBuilderCategories(array: Array<any>, callback: (any) => any): any[] {
    let result = [];
    array.forEach((item) => {
      result.push(callback(item));
    });

    return result;
  }

  private initialiseFields() {

    const clientParentRef = { name: 'Client Parent', type: 'number', operators: FilterOperators.AdminScalar };
    this.fieldMetaDataCollection.set(clientParentRef.name, new FieldMetadata('ClientParentRef', clientParentRef));

    const clientRef = { name: 'Client', type: 'number', operators: FilterOperators.AdminScalar };
    this.fieldMetaDataCollection.set(clientRef.name, new FieldMetadata('ClientRef', clientRef));

    const subLedger = {
      name: 'Sub Ledger',
      type: 'category',
      operators: FilterOperators.CategoryDefaults,
      options: this.getQueryBuilderCategories(this.subLedgers, (subLedger: SubLedgerModel) => {
        return {
          label: `${subLedger.Code} - ${subLedger.Description}`,
          name: `${subLedger.Code} - ${subLedger.Description}`,
          value: subLedger.Description
        }
      }),
      defaultValue: this.subLedgers[0].Description
    };
    const type = {
      name: 'Type',
      type: 'category',
      operators: FilterOperators.CategoryDefaults,
      options: this.getQueryBuilderCategories(this.types, (type: string) => {
        return {
          label: type,
          name: type,
          value: type
        }
      }),
      defaultValue: this.types[0]
    };
    this.fieldMetaDataCollection.set(subLedger.name, new FieldMetadata('SubLedger', subLedger));
    this.fieldMetaDataCollection.set(type.name, new FieldMetadata('Type', type));
  }

  getFilterFields(): Array<Field> {
    return this.fieldMetaDataCollection.getFilterFields();
  }


  getFilterField(fieldName: string): Field {
    return this.fieldMetaDataCollection.getFilterField(fieldName);
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

}
